import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// import { getMessaging} from "firebase/messaging/sw";

// var firebaseConfig = {
//   apiKey: "AIzaSyCSpasDGiBLVU8MI-mpGoBbcxfGm5-OfSQ",
//   authDomain: "edubricz-6de74.firebaseapp.com",
//   databaseURL: "https://edubricz-6de74-default-rtdb.firebaseio.com",
//   projectId: "edubricz-6de74",
//   storageBucket: "edubricz-6de74.appspot.com",
//   messagingSenderId: "720886504391",
//   appId: "1:720886504391:web:e163ad5b5d990abd3e17e2",
//   measurementId: "G-WGHGB6ZVLC"
// };

const firebaseConfig = {
  apiKey: "AIzaSyAarQAiTumkpfcCUCmJcm2O6KkKzDDYP4U",
  authDomain: "edubricz-6de74.firebaseapp.com",
  databaseURL: "https://edubricz-6de74-default-rtdb.firebaseio.com",
  projectId: "edubricz-6de74",
  storageBucket: "edubricz-6de74.appspot.com",
  messagingSenderId: "720886504391",
  appId: "1:720886504391:web:e163ad5b5d990abd3e17e2",
  measurementId: "G-WGHGB6ZVLC"
};

const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const fetchToken = (setTokenFound) => {
  let token=''
  getToken(messaging, { vapidKey: 'BPwRzdHP8d5fmrX8ZNU9nvi6UfupT_ElUsT0jlViy-5e2XrIVRkdhGiaN0qdh34naVQIKmmQtZTONIct7bfJo8M' }).then((currentToken) => {
    if (currentToken) {
      token = currentToken
      setTokenFound(currentToken);
    } else {
      console.log('No registration token available. Request permission to generate one.');
      setTokenFound(false);
      Notification.requestPermission();
    }
  }).catch((err) => {
    console.log('An error occurred while retrieving token. ', err);
  })
}

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });